<mat-card class="progress-bar-card column">
  <div class="row">
    <h2>Current Month</h2>
    <span
      ><b>{{ bandwidth().totalUsage | bytesToSize }}</b> /
      {{ plan() ? (bandwidthLimit() | bytesToSize) : 'N/A' }}</span
    >
  </div>
  <mat-progress-bar mode="determinate" [value]="bandwidthPercent()" id="bar"></mat-progress-bar>
  <span class="hint">The Bandwidth limit resets on every 1st of the month</span>
</mat-card>

<div class="websites">
  <h2>Bandwidth Usage per Website</h2>
  <app-search-field
    placeholder="Search website"
    id="record-search"
    (searchText)="onSearch($event)"
  ></app-search-field>
  <mat-card class="websites-card">
    <app-table
      #table
      [columns]="websitesColumns"
      [dataSource]="websitesData()"
      [totalCount]="websitesData().length"
      (pageChange)="handlePageEvent($event)"
    >
      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="buttons row">
            <button matRipple class="icon-button">
              <fa-icon [icon]="['fas', 'chart-column']" size="lg"></fa-icon>
            </button>
          </div>
        </td>
      </ng-container>
    </app-table>
  </mat-card>
</div>
